import ReactLoading from 'react-loading'

interface Props {
  size?: number
  color?: string
}
export function Spinner({ size = 50, color = 'gray' }: Props) {
  return <ReactLoading type={'spin'} color={color} height={size} width={size} />
}
